import React from "react";
import { Mail, MapPin, Github, Phone } from "lucide-react";

const ContactPage: React.FC = () => {
  return (
    <div className="flex justify-center items-start min-h-screen bg-orange-50 pt-[120px] pb-[80px] px-4">
      <div className="bg-white/90 backdrop-blur-sm shadow-xl rounded-2xl p-8 sm:p-10 max-w-3xl w-full text-center border border-orange-100">
        {/* === TITLE === */}
        <h1 className="text-3xl sm:text-4xl font-bold text-orange-600 mb-4">
          📬 Kontakt oss
        </h1>

        {/* === INTRO === */}
        <p className="text-gray-700 leading-relaxed mb-6">
          Har du spørsmål, tilbakemeldinger eller forslag? Vi vil gjerne høre
          fra deg! Ta kontakt med oss gjennom kanalene under.
        </p>

        <hr className="border-orange-200 my-6" />

        {/* === CONTACT INFO === */}
        <div className="space-y-6 text-gray-700">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
            <Mail className="text-orange-600" size={20} />
            <a
              href="mailto:post@fontenehuset-oslosor.no"
              className="hover:underline"
            >
              post@fontenehuset-oslosor.no
            </a>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
            <Phone className="text-orange-600" size={20} />
            <span>+47 922 86 666</span>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
            <MapPin className="text-orange-600" size={20} />
            <span>
              Fontenehuset Oslo Sør, Klemetsrudveien 50, 1278 Oslo, Norge
            </span>
          </div>
        </div>

        <hr className="border-orange-200 my-6" />

        {/* === COMMUNITY / TEAM === */}
        <div className="text-gray-700 leading-relaxed">
          <p className="mb-4">
            FonteneLunsj er utviklet i samarbeid med fellesskapet på
            Fontenehuset Oslo Sør og frivillige utviklere.
          </p>
        </div>

        {/* === LINKS === */}
        <div className="mt-8 flex justify-center items-center gap-6">
          <a
            href="https://github.com/Fontenehuset-Mortensrud"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-orange-600 hover:text-orange-700 transition"
          >
            <Github size={18} />
            GitHub
          </a>
        </div>

        {/* === FOOTER TEXT === */}
        <p className="text-sm text-gray-500 italic mt-10">
          Vi svarer deg så fort vi kan 💛
        </p>
      </div>
    </div>
  );
};

export default ContactPage;
